import React from 'react'

interface Product {
  reviewDate: string
  name: string
  ratingValue: number
  reviewCount: number
  reviewerName?: string
  shortReviewSnippet?: string
}

interface StructuredRatingsAndReviewsProps {
  products: Product[]
  enableProductSchema: boolean
}

export const StructuredRatingsAndReviews = (
  props: StructuredRatingsAndReviewsProps
): JSX.Element | null => {
  if (props.enableProductSchema) {
    const ldJSON = props.products.map((product) => {
      const review = {
        '@type': 'Review',
        reviewBody: product.shortReviewSnippet,
        author: {
          '@type': 'Person',
          name: product.reviewerName,
        },
        datePublished: product.reviewDate,
      }

      const productSchema = {
        '@context': 'https://schema.org',
        '@type': 'Product',
        name: product.name,
        aggregateRating: {
          '@type': 'AggregateRating',
          ratingValue: product.ratingValue,
          reviewCount: product.reviewCount,
          bestRating: 5,
          worstRating: 1,
        },
        ...(product.reviewerName && product.shortReviewSnippet && { review }),
      }

      return productSchema
    })

    return (
      <>
        {ldJSON.map((schema, index) => (
          <script
            key={index}
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
          />
        ))}
      </>
    )
  }

  return null
}
